import CategoryReportsContainer from "./CategoryReportsContainer";

export default CategoryReportsContainer;
